import { useState } from "react";
import ApiData from "../../api/ApiData";
import Msg from "../../api/Msg";
import { InputEditVer1 } from "../UI/InputEditVer1";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { SiteModalHeader } from "../UI/SiteModalHeader";
import { SiteFormField } from "../UI/SiteFormField";
import { SiteModalToolbarBtn } from "../company/SiteModalToolbarBtn";

export const InfoComponent = ({ edit, setEdit }) => {
  const profile = ApiData.user_profile;
  const [firstName, setFirstName] = useState(profile?.first_name);
  const [lastName, setLastName] = useState(profile?.last_name);
  const [fatherName, setFatherName] = useState(profile?.father_name);
  const [phone, setPhone] = useState(profile?.phone);
  const [passwordOpen, setPasswordOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [repeatPassword, setrepeatPassword] = useState("");
  const [passVisibleOne, setPassVisibleOne] = useState(false);
  const [passVisibleTwo, setPassVisibleTwo] = useState(false);

  const closeEditor = () => {
    setPasswordOpen(false);
    setPassword("");
    setrepeatPassword("");
    setEdit(false);
  };

  const editPasswordFucn = () => {
    if (password !== repeatPassword) {
      return Msg.writeMessages("Пароли не совпадают");
    }
    ApiData.updatePasswordUser(password);
    setPasswordOpen(false);
    setPassword("");
    setrepeatPassword("");
  };

  const editProfileFucn = async () => {
    const dataPersone = {};
    if (firstName !== "") {
      dataPersone.first_name = firstName;
    }
    if (lastName !== "") {
      dataPersone.last_name = lastName;
    }
    if (fatherName !== "") {
      dataPersone.father_name = fatherName;
    }
    if (phone !== "") {
      dataPersone.phone = phone;
    }

    const res = await ApiData.updateUser(dataPersone);
    closeEditor();
    if (res.status === 200) {
      Msg.writeMessages("Сохранено");
    } else {
      Msg.writeMessages("Ничего не было изменено");
    }
  };

  if (!edit) {
    return null;
  }

  return (
    <section
      className="card dash-card company-edit-panel profile-edit-panel"
      aria-labelledby="profile-edit-title"
    >
      <SiteModalHeader
        title="Редактирование профиля"
        titleId="profile-edit-title"
        toolbarWrap={false}
        toolbar={
          <SiteModalToolbarBtn
            variant="close"
            onClick={closeEditor}
            title="Отменить редактирование"
          />
        }
      />

      <div className="company-edit-meta">
        <div className="company-edit-inn-row">
          <span className="site-form-label">Email</span>
          <span className="company-edit-inn-value company-card-v4-mono">
            {profile?.email}
          </span>
        </div>
      </div>

      <div className="company-edit-grid">
        <SiteFormField label="Фамилия">
          <InputEditVer1
            className="site-form-control"
            placeholder={profile?.last_name}
            value={lastName ?? ""}
            onChange={(e) => setLastName(e.target.value)}
          />
        </SiteFormField>

        <SiteFormField label="Имя">
          <InputEditVer1
            className="site-form-control"
            placeholder={profile?.first_name}
            value={firstName ?? ""}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </SiteFormField>

        <SiteFormField label="Отчество">
          <InputEditVer1
            className="site-form-control"
            placeholder={profile?.father_name}
            value={fatherName ?? ""}
            onChange={(e) => setFatherName(e.target.value)}
          />
        </SiteFormField>

        <SiteFormField label="Телефон" full>
          <InputEditVer1
            className="site-form-control"
            placeholder={profile?.phone}
            value={phone ?? ""}
            onChange={(e) => setPhone(e.target.value)}
          />
        </SiteFormField>
      </div>

      {passwordOpen ? (
        <div className="profile-password-fields profile-password-fields--in-edit">
          <h3 className="profile-panel-title">Смена пароля</h3>
          <SiteFormField label="Новый пароль">
            <div className="profile-password-input-row">
              <InputEditVer1
                className="site-form-control"
                placeholder="Придумайте пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={passVisibleOne ? "text" : "password"}
              />
              <button
                type="button"
                className="profile-password-visibility-btn"
                onClick={() => setPassVisibleOne((v) => !v)}
                aria-label={
                  passVisibleOne ? "Скрыть пароль" : "Показать пароль"
                }
              >
                {passVisibleOne ? "Скрыть" : "Показать"}
              </button>
            </div>
          </SiteFormField>

          <SiteFormField label="Повторите пароль">
            <div className="profile-password-input-row">
              <InputEditVer1
                className="site-form-control"
                placeholder="Повторите пароль"
                value={repeatPassword}
                onChange={(e) => setrepeatPassword(e.target.value)}
                type={passVisibleTwo ? "text" : "password"}
              />
              <button
                type="button"
                className="profile-password-visibility-btn"
                onClick={() => setPassVisibleTwo((v) => !v)}
                aria-label={
                  passVisibleTwo ? "Скрыть пароль" : "Показать пароль"
                }
              >
                {passVisibleTwo ? "Скрыть" : "Показать"}
              </button>
            </div>
          </SiteFormField>

          <div className="profile-password-inline-actions">
            <BtnPrimaryv4
              onClick={editPasswordFucn}
              text="Сохранить пароль"
              footerSize
            />
            <BtnOutlineV4
              onClick={() => {
                setPasswordOpen(false);
                setPassword("");
                setrepeatPassword("");
              }}
              text="Отмена"
            />
          </div>
        </div>
      ) : null}

      <footer className="site-modal-footer profile-edit-footer">
        <BtnPrimaryv4
          onClick={editProfileFucn}
          text="Сохранить изменения"
          footerSize
        />
        <BtnOutlineV4 onClick={closeEditor} text="Отмена" />
        {!passwordOpen ? (
          <BtnOutlineV4
            onClick={() => setPasswordOpen(true)}
            text="Сменить пароль"
            className="profile-change-password-btn"
          />
        ) : null}
      </footer>
    </section>
  );
};
